<template>
  <div id="app">
<!--    <img src="./assets/logo.png">-->
    <!--路由管道标签，任何符合某一路由(route)信息的组件都会在这个标签内展示出来 -->
    <router-view/>
  </div>
</template>

<script>
import share from './view/share/share'
import privacyTerm from './view/userAgreement/revolo_privacy_term'
import userTerm from './view/userAgreement/revolo_user_term'

// 文件下载
import downloadRevolo from './view/download/revolo'

export default {
  comments: {
    share,
    privacyTerm,
    userTerm,
    downloadRevolo
  },
  name: 'App'
}
</script>



// WEBPACK FOOTER //
// src/App.vue